import React, { useState, useEffect } from 'react';
import jsyaml from 'js-yaml';
import ConverterLayout from './ConverterLayout';
import { Alert, Box, Typography } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';

function JsonToYaml() {
  const [json, setJson] = useState('{\n  "id": 1,\n  "name": "Item A"\n}');
  const [yaml, setYaml] = useState('');
  const [error, setError] = useState('');

  const handleConvert = () => {
    setError('');
    if (!json.trim()) {
      setYaml('');
      return;
    }

    try {
      const doc = JSON.parse(json);
      setYaml(jsyaml.dump(doc));
    } catch (e) {
      setError(e.message);
      setYaml('');
    }
  };

  const handleClear = () => {
    setJson('');
    setYaml('');
    setError('');
  };

  useEffect(() => {
    handleConvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="JSON to YAML Converter | Free Online Tool | UmbrellaCo"
        description="Instantly convert JSON to valid YAML online. Free tool to transform JSON configuration files into human-readable YAML."
        keywords="json to yaml, convert json to yaml, json to yaml converter online, parse json, online json tools"
        url="/json-tools/json-to-yaml"
        jsonLd={createSoftwareAppSchema(
          'JSON to YAML Converter',
          'Instantly convert JSON objects to valid YAML configurations.',
          'https://umbrellaco.in/json-tools/json-to-yaml',
          ['JSON Parsing', 'YAML Formatting', 'Data Conversion']
        )}
      />
      {error && <Alert severity="error" sx={{ mx: 2, mb: 1 }}>{error}</Alert>}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <ConverterLayout
          title="JSON to YAML Converter"
          description="Translate strictly formatted JSON objects into human-readable YAML configurations."
          leftTitle="JSON"
          rightTitle="YAML"
          leftLanguage="json"
          rightLanguage="yaml"
          leftValue={json}
          setLeftValue={setJson}
          rightValue={yaml}
          onConvert={handleConvert}
          onClear={handleClear}
        />
      </Box>
    </Box>
  );
}

export default JsonToYaml;
